import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionAmlCtfSanctionsOrDefaults } from '@/features/institution/aml-ctf-sanctions/schema';

const InstitutionAmlCtfSanctionsFieldsetProhibitedRelationships = () => {
  const form = useFormContext<InstitutionAmlCtfSanctionsOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="prohibitsAnonymousAccounts"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsAnonymousAccounts')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsAnonymousAccounts')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="prohibitsUnlicensedBankAccounts"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsUnlicensedBankAccounts')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsUnlicensedBankAccounts')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="prohibitsServicesToUnlicensedBanks"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsServicesToUnlicensedBanks')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsServicesToUnlicensedBanks')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="prohibitsShellBanks"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsShellBanks')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsShellBanks')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="prohibitsServicesToShellBanks"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsServicesToShellBanks')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.amlCtfSanctions.prohibitedRelationships.prohibitsServicesToShellBanks')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionAmlCtfSanctionsFieldsetProhibitedRelationships.displayName = 'InstitutionAmlCtfSanctionsFieldsetProhibitedRelationships';

export { InstitutionAmlCtfSanctionsFieldsetProhibitedRelationships };
